import styled from 'styled-components/macro'

interface FlexRowProps {
  justify?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-around'
    | 'space-between'
    | 'stretch'
  align?: 'flex-start' | 'center' | 'flex-end' | 'stretch'
}

const FlexRow = styled.div<FlexRowProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.justify || 'flex-start'};
  align-items: ${props => props.align || 'flex-start'};
`

export default FlexRow
